
export default class NewYearAPI {
    constructor () {
        let currentUrl = new URL(document.location);
        this.urlRequestAPI = `${currentUrl.protocol}//${currentUrl.host}/api/v2/newyear/`;
    }

    requestData(url, errorMessage) {
        return fetch(url)
                .then( response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        let error = new Error(response.statusText);
                        error.response = response;
                        throw error;
                    }
                })
                .catch((error) => {
                    this.showErrorLink(errorMessage);
                    console.log(error);
                });
                
    }

    getNewYearInfo () {
        let url = new URL(`${this.urlRequestAPI}info`);
        return this.requestData(url, 'getNewYearInfo error');
    }

    getNewYearTracks () {
        let url = new URL(`${this.urlRequestAPI}tracks`);
        return this.requestData(url, 'getNewYearInfo error');
    }
}